module.exports = "/assets/data/433f893d50d683b7f0f9aac0cacdb2a2-DE12.data.json";